import { Injectable } from '@angular/core';
import { API_URLS } from '@core/api-url.enum';
import { ApiCallService } from '@services/api-call.service';

export interface RecordPlayPayload {
  pk: string;
  sk: string;
  duration_played: number;
  session_id: string;
}

@Injectable({
  providedIn: 'root'
})
export class PortfolioRecordPlayService {
  constructor(private readonly apiCallService: ApiCallService) {}

  recordPlay(payload: RecordPlayPayload): void {
    if (!payload.duration_played) return;

    this.apiCallService
      .post(API_URLS.portfolioRecordPlay, payload, false)
      .subscribe();
  }
}
